module.exports = __webpack_public_path__ + "img/JobInterview-1.83feeee7.svg";